import { Benefit } from "@/api/products";
import { ReactNode } from "react";

const benefitIcons = {
  unlimitedSms: "/icons/sms.png",
  unlimitedCall: "/icons/brasil.png",
  Roaming: "/icons/plane.png",
  TimOnPlane: "/icons/plane.png",
  Wifi: "/icons/wifi.png",
};
export type MinuteBenefitsTypes = keyof typeof benefitIcons;

export const MinuteBenefitsItem = ({
  component,
  children,
}: {
  component?: MinuteBenefitsTypes;
  children?: ReactNode;
}) => {
  return (
    <div className="mt-2 flex items-center text-base text-gray-700">
      <img
        src={benefitIcons[component!] || "/check.svg"}
        alt={component}
        width={24}
      />
      <span className="ml-2">
        <strong className="font-normal">{children}</strong>
      </span>
    </div>
  );
};

export function MinuteBenefits({ benefits }: { benefits: Benefit[] }) {
  const unlimitedCall = benefits.find(
    ({ componente }) => componente === "unlimitedCall"
  );
  const unlimitedSms = benefits.find(
    ({ componente }) => componente === "unlimitedSms"
  );
  const roaming = benefits.find(({ componente }) => componente === "Roaming");
  const timOnPlane = benefits.find(
    ({ componente }) => componente === "TimOnPlane"
  );
  const wifi = benefits.find(({ componente }) => componente === "Wifi");

  return (
    <div className="mt-2">
      {unlimitedCall && (
        <MinuteBenefitsItem
          component={unlimitedCall.componente as MinuteBenefitsTypes}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: boldAsNeeded(unlimitedCall.descricao),
            }}
          />
        </MinuteBenefitsItem>
      )}
      {unlimitedSms && (
        <MinuteBenefitsItem
          component={unlimitedSms.componente as MinuteBenefitsTypes}
        >
          <span
            dangerouslySetInnerHTML={{
              __html: boldAsNeeded(unlimitedSms.descricao),
            }}
          />
        </MinuteBenefitsItem>
      )}
      {roaming && (
        <MinuteBenefitsItem
          component={roaming.componente as MinuteBenefitsTypes}
        >
          {roaming.descricao}
        </MinuteBenefitsItem>
      )}
      {timOnPlane && (
        <MinuteBenefitsItem
          component={timOnPlane.componente as MinuteBenefitsTypes}
        >
          {timOnPlane.descricao}
        </MinuteBenefitsItem>
      )}
      {wifi && (
        <MinuteBenefitsItem component={wifi.componente as MinuteBenefitsTypes}>
          {wifi.descricao}
        </MinuteBenefitsItem>
      )}
    </div>
  );
}

function boldAsNeeded(label: string) {
  const keywords = ["Ligações ilimitadas", "SMS ilimitado"];

  keywords.forEach((keyword) => {
    if (label.includes(keyword)) {
      label = label.replace(keyword, `<strong>${keyword}</strong>`);
    }
  });

  return label;
}
